import { createSlice } from "@reduxjs/toolkit";
import {getTestimonialList } from "./ThunkActions";
import { iTestimonialState, REDUCER_NAME } from "./Types";

const initialState: iTestimonialState = {
  isLoading: false,
  testimonialList: [], 
  errorMessage: null,
};

export const testimonialSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetTestimonialState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTestimonialList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTestimonialList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.testimonialList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getTestimonialList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Coupon data";
        state.isLoading = false;
      })
      
     
  },
});

export const { resetTestimonialState } = testimonialSlice.actions;
export default testimonialSlice.reducer;
  